import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../util/assets';
import PriceDisplay from '../../PriceDisplay';
import Badge from '../../Badge';
import { REQUIRES_PRINT_PACKAGE_ALERT_MODAL } from '../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/components/RequiresPrintPackageAlert';
import useOpenModal from '../../../../hooks/useOpenModal';
import CheckoutItemQuantityInput from '../../../../services/checkout/components/CheckoutCartItem/CheckoutItemQuantityInput';

const propTypes = {
  className: PropTypes.string,
  photoPricingPrintProductItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    print_product: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    print_product_size: PropTypes.shape({
      id: PropTypes.string.isRequired,
      print_size: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledElement: PropTypes.node,
  cartItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onCartItemToggle: PropTypes.func.isRequired,
  onCartItemUpdate: PropTypes.func.isRequired,
};

const PrintProductIndividual = ({
  className,
  photoPricingPrintProductItem,
  readOnly,
  disabled,
  disabledElement,
  cartItem,
  onCartItemToggle,
  onCartItemUpdate,
}) => {
  const openModal = useOpenModal();
  const classes = classNames({
    [className]: !!className,
    'purchasing-option-item': true,
    'purchasing-option-item-print-product': true,
  });

  const {
    print_product: printProduct = {},
    print_product_size: printProductSize = {},
  } = photoPricingPrintProductItem ?? {};

  const previewImage =
    printProductSize?.preview_asset_image?.url ??
    printProduct?.preview_asset_image?.url;

  return (
    <Fragment>
      <div
        className={classes}
        data-testid={`PrintProductIndividual-${photoPricingPrintProductItem.id}`}
      >
        <div className="purchasing-option-item-thumb">
          <img
            width={previewImage ? 80 : 60}
            src={previewImage || getAsset('/simple-prints-illustration.svg')}
            alt=""
          />
        </div>

        <div className="purchasing-option-item-content-wrap">
          <div className="purchasing-option-item-title">
            <div className="text-truncate">
              {printProductSize?.print_size?.name}
            </div>
            <div className="purchasing-option-item-info-extra">
              <Badge badgeStyle="yellow" className="text-extra-bold">
                <PriceDisplay
                  price={photoPricingPrintProductItem.price.value}
                  currency={photoPricingPrintProductItem.price.currency}
                />
              </Badge>
            </div>
          </div>
          <p className="mb-0 text-xs text-dark">
            {(printProduct?.name ?? '').replace(
              ' (configured as rendered sheets)',
              '',
            )}
          </p>

          {disabled && disabledElement && !readOnly && <>{disabledElement}</>}

          {!readOnly && (
            <CheckoutItemQuantityInput
              min={0}
              className="mt-1"
              onChange={value => {
                if (disabled) {
                  openModal(REQUIRES_PRINT_PACKAGE_ALERT_MODAL, {
                    name: `${printProduct.name} - ${printProductSize.name}`,
                  });
                  return;
                }

                if ((!cartItem && value > 0) || (!!cartItem && value === 0)) {
                  // Either no cart item in cart or removing cart item.
                  onCartItemToggle({
                    printProduct,
                    printProductSize,
                  });
                  return;
                }

                // Else, update the quantity.
                onCartItemUpdate(cartItem.id, {
                  quantity: value,
                });
              }}
              value={cartItem?.quantity || 0}
              label=""
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

PrintProductIndividual.propTypes = propTypes;

export default PrintProductIndividual;
